// tabs.
import { $$ } from './core.ts';

// ---------------- T-072: tabs, action menus, rail tooltips ----------------
export function initTabs(root: ParentNode = document): void {
  $$('.ds-tabs[role="tablist"]', root).forEach(list => {
    if (list.dataset.dsReady) return;
    list.dataset.dsReady = '1';
    const tabs = $$('[role="tab"]', list);
    const select = (t: HTMLElement, focus?: boolean, user?: boolean): void => {
      tabs.forEach(x => {
        const on = x === t;
        x.setAttribute('aria-selected', String(on));
        x.tabIndex = on ? 0 : -1;
        const p = document.getElementById(x.getAttribute('aria-controls')!);
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
      if (user && list.dataset.remember !== undefined && t.id) history.replaceState(null, '', '#' + t.id); // only a user's choice goes into the address
      t.dispatchEvent(new CustomEvent('ds:tab', { bubbles: true }));
    };
    list.addEventListener('click', e => {
      const t = (e.target as Element).closest<HTMLElement>('[role="tab"]');
      if (t && list.contains(t)) select(t, false, true);
    });
    list.addEventListener('keydown', e => {
      const i = tabs.indexOf(document.activeElement as HTMLElement);
      if (i < 0) return;
      const n =
        e.key === 'ArrowLeft'
          ? tabs[(i + 1) % tabs.length]
          : e.key === 'ArrowRight'
            ? tabs[(i - 1 + tabs.length) % tabs.length]
            : e.key === 'Home'
              ? tabs[0]
              : e.key === 'End'
                ? tabs[tabs.length - 1]
                : null;
      if (n) {
        e.preventDefault();
        select(n, true, true);
      }
    });
    const fromHash =
      location.hash && tabs.find(t => '#' + t.id === location.hash || '#tab-' + location.hash.slice(1) === '#' + t.id); // #tab-x or the plain #x older links use
    if (tabs.length) select(fromHash || tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0]);
  });
}
